import type { IndicatorProps } from "@mantine/core";

import { Indicator } from "@mantine/core";

import classes from "../chat-components.module.css";

interface QueuedChatIndicatorProps extends IndicatorProps {
    size: number;
    visible: boolean;
}

export const QueuedChatIndicator = ({ children, visible, size, ...rest }: QueuedChatIndicatorProps) => {
    return (
        <Indicator
            classNames={{
                indicator: classes.queued_chat_indicator,
                root: classes.queued_chat_indicator_root,
            }}
            inline
            withBorder
            {...rest}
            size={size}
            position="top-end"
            disabled={!visible}
        >
            {children}
        </Indicator>
    );
};
